"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGISTRATION_ACTION = void 0;
exports.REGISTRATION_ACTION = 'login';
//# sourceMappingURL=constants.js.map